import { extend } from 'flarum/common/extend';
import Dropdown from 'flarum/common/components/Dropdown';

// The header's own menus, and its "…" one, which holds those the row has no
// room for (tablet widths), all of them unfolded (see forum.less). Of the
// "…" dropdown's own menu and those inside it, querySelector() takes the
// first in document order: its own, their ancestor.
const MENU_SELECTOR = '.ChampisForumsMenu-menu, #header-primary .OverflowingList-dropdown > .Dropdown-menu';

// Kept free below a menu, so its end doesn't touch the screen's edge.
const BOTTOM_MARGIN = 10;

// Never less: on a very short window, a menu that scrolls the page along
// with it beats one that only shows a few lines.
const MIN_HEIGHT = 200;

// The header's long menus (.ChampisForumsMenu-menu: Espèces, Articles,
// Forums, Divers, Règles/Aide) scroll once taller than the screen - but
// forum.less' `max-height: calc(100vh - 80px)` assumes they start 80px
// down, as they do once the page is scrolled. At its top they start under
// the 120px photo banner too, ~170px down, so the end of the longest ones
// (Forums, and Divers' last group, Communauté) ran off the bottom of the
// screen. Each is capped here to the room actually left below it: as it
// opens, and again while the page scrolls under it, since the banner
// scrolling away gives it more room (or scrolling back, less).
//
// Only a menu dropping down from the header (position: absolute): in the
// phone's side drawer, the same menus open inline, within the drawer's
// own scrolling, and keep the stylesheet's cap.
function fit(menu) {
  if (getComputedStyle(menu).position !== 'absolute') return;
  const room = window.innerHeight - menu.getBoundingClientRect().top - BOTTOM_MARGIN;
  menu.style.maxHeight = `${Math.max(room, MIN_HEIGHT)}px`;
}
export default function fitHeaderMenusToViewport() {
  extend(Dropdown.prototype, 'oncreate', function (value, vnode) {
    const menu = vnode.dom.querySelector(MENU_SELECTOR);
    if (!menu) return;
    const onScroll = () => {
      // Gone with its menu (a page re-rendering the header) while open.
      if (!menu.isConnected) {
        window.removeEventListener('scroll', onScroll);
        return;
      }
      fit(menu);
    };
    $(vnode.dom).on('shown.bs.dropdown', () => {
      fit(menu);
      window.addEventListener('scroll', onScroll, {
        passive: true
      });
    }).on('hidden.bs.dropdown', () => window.removeEventListener('scroll', onScroll));
  });
}